// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"an-z","badgeLink":"bn-z","category":"cn-z"};